import React, { useState, useEffect, useCallback } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Process from './components/Process';
import PackageQuiz from './components/PackageQuiz';
import Packages from './components/Packages';
import ProjectRequestForm from './components/ProjectRequestForm';
import IntakeForm from './components/IntakeForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ParticleField from './components/ParticleField';

function App() {
  const [requestData, setRequestData] = useState(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [preSelectedPackageId, setPreSelectedPackageId] = useState(null);

  const handleSubmitRequest = useCallback((packageName, tier) => {
    setRequestData({ packageName, tier });
    setShouldScroll(true);
  }, []);

  const handleQuizRecommendation = useCallback((packageId) => {
    setPreSelectedPackageId(packageId);
    setTimeout(() => {
      document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }, []);

  useEffect(() => {
    if (shouldScroll && requestData) {
      const scrollToForm = () => {
        const el = document.getElementById('project-request');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setShouldScroll(false);
        } else {
          setTimeout(scrollToForm, 50);
        }
      };
      setTimeout(scrollToForm, 50);
    }
  }, [shouldScroll, requestData]);

  return (
    <div className="App">
      <ParticleField />
      <Navbar />
      <Hero />
      <Process />
      <PackageQuiz onRecommend={handleQuizRecommendation} />
      <Packages onCheckout={handleSubmitRequest} preSelectedPackageId={preSelectedPackageId} />
      <FAQ />
      {requestData && (
        <ProjectRequestForm
          packageName={requestData.packageName}
          tier={requestData.tier}
        />
      )}
      <IntakeForm />
      <Footer />
    </div>
  );
}

export default App;
